import { useState, useEffect } from 'react'
import { DashboardMetricsCards } from '../components/analytics/DashboardMetricsCards'
import { ActivityChart } from '@/components/analytics/ActivityChart';
import { NewUsersChart } from '@/components/analytics/NewUsersChart'
import { NewAlbumsChart } from '@/components/analytics/NewAlbumsChart'
import { NewPhotosChart } from '@/components/analytics/NewPhotosChart'
import { NewTripsChart } from '@/components/analytics/NewTripsChart'
import { NewEventsChart } from '@/components/analytics/NewEventsChart';
import { analyticsService } from '@/services/analyticsService'
import { DashboardMetrics } from '@/types'
import toast from 'react-hot-toast'

export const DashboardPage = () => {
  const [metrics, setMetrics] = useState<DashboardMetrics | null>(null)
  const [loading, setLoading] = useState(true)

    useEffect(() => {
    const fetchMetrics = async () => {
      try {
        setLoading(true)
        const data = await analyticsService.getDashboardMetrics()
        setMetrics(data)
      } catch (error: any) {
        console.error('Failed to fetch dashboard metrics:', error)
        const errorMessage = error.response?.data?.error || 'Failed to load dashboard data'
        toast.error(errorMessage)
        
        // Fallback to mock data for demo purposes
        const mockMetrics: DashboardMetrics = {
          totalUsers: {
            value: 15420,
            change: 12.5,
            changeType: 'increase'
          },
          activeUsersToday: {
            value: 1247,
            change: -3.2,
            changeType: 'decrease'
          },
          totalEvents: {
            value: 3456,
            change: 15.2,
            changeType: 'increase'
          },
          totalTrips: {
            value: 8923,
            change: 0,
            changeType: 'neutral'
          },
          totalAlbums: {
            value: 2345,
            change: 11.7,
            changeType: 'increase'
          },
          totalPhotos: {
            value: 45678,
            change: -5.1,
            changeType: 'decrease'
          },
          eventTripPhotos: {
            value: 12345,
            change: 18.9,
            changeType: 'increase'
          }
        }
        setMetrics(mockMetrics)
      } finally {
        setLoading(false)
      }
    }

    fetchMetrics()
  }, [])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!metrics) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-medium text-gray-900">Failed to load dashboard</h3>
        <p className="mt-2 text-sm text-gray-500">Please try refreshing the page.</p>
      </div>
    )
  }

  return (
     <div className='space-y-6'>
        <div>
           <h1 className='text-2xl font-bold text-gray-900'>Dashboard Overview</h1>
           <p className='mt-1 text-sm text-gray-500'>
              Monitor your platform's performance and user activities in real-time.
           </p>
        </div>

        <DashboardMetricsCards metrics={metrics} />

        <div className='grid grid-cols-1 gap-6'>
           <ActivityChart />
        </div>

        {/* New Users, Albums, Photos, Trips, and Events Detailed Charts */}
        <div className='grid grid-cols-1 xl:grid-cols-3 gap-6'>
           <NewUsersChart />
           <NewAlbumsChart />
           <NewPhotosChart />

           <NewTripsChart />
           <NewEventsChart />
        </div>
     </div>
  );
} 